export default __webpack_public_path__ + "static/media/nuts.91e4140b.svg";